module.exports = __webpack_public_path__ + "media/images/restaurant/areas/near_tokyo_m-9a7faa098badfe929cc6cb5fe788c2a5.png";